import { FieldEditorProps } from './FieldEditorProps';
import AsyncSelect from 'Shared/components/AsyncSelect'
import ColorCodeOption from './components/ColorCodeOption'
import '../styles/Editors.scoped.scss';
import Checkbox from 'Shared/components/Checkbox'

export const GoalFieldEditor = ({ field, onChange }: FieldEditorProps) => {
  return <>
    <div className="field-editor-row">
      <label>Goal</label>
      <div className='field-editor-input'>
        <AsyncSelect
          entity="goal"
          value={field?.goalId}
          rootClassName="grow"
          onChange={(id) => onChange({ goalId: id })}
        />
      </div>
    </div>
    <div className="field-editor-row">
      <div className='field-editor-input'>
        <Checkbox
          label="Allow Organisers to complete goal"
          checked={field.source === 'completable_goal'}
          onChange={(e) => onChange({ source: e.target.checked ? 'completable_goal' : 'goal' })}
        />
      </div>
    </div>
    <ColorCodeOption field={field} onChange={onChange} />
  </>
}
